<div id="contentDetailWindowDocument">
  <div style="overflow: auto">
    <table class="table-content">
      <tr>
        <td colspan="3">
          <table class="table-detail">
            <tr>
              <td id="tdDesignationInput" style="width: 64.67%">
                <abcInput
                  #designationInput
                  [style]="4"
                  id="Designation"
                  [placeholder]="'Designation'"
                  [width]="'95%'"
                  [height]="'40px'"
                ></abcInput>
              </td>
              <td style="width: 33.33%">
                <abcDatepicker
                  #dateInput
                  id="Date"
                  [style]="4"
                  [placeholder]="'Date'"
                  [width]="'100%'"
                  [height]="'40px'"
                ></abcDatepicker>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <abcInput
            #fileNameInput
            id="FileName"
            [style]="4"
            [placeholder]="'Filename'"
            [width]="'100%'"
            [height]="'40px'"
          ></abcInput>
        </td>
      </tr>
      <tr>
        <td>
          <abcInput
            #documentKindInput
            id="DocumentKind"
            [style]="4"
            [placeholder]="'Document Kind'"
            [width]="'95%'"
            [height]="'40px'"
          ></abcInput>
        </td>
        <td>
          <abcInput
            #dataCarrierInput
            id="DataCarrier"
            [style]="4"
            [placeholder]="'Data carrier'"
            [width]="'95%'"
            [height]="'40px'"
          ></abcInput>
        </td>
        <td>
          <abcInput
            #numberInput
            id="Number"
            [type]="'number'"
            [style]="4"
            [placeholder]="'Number'"
            [width]="'100%'"
            [height]="'40px'"
          >
          </abcInput>
        </td>
      </tr>

      <tr>
        <td colspan="3">
          <abcInput
            #programPathInput
            id="ProgramPath"
            [style]="4"
            [placeholder]="'Program path'"
            [width]="'100%'"
            [height]="'40px'"
          ></abcInput>
        </td>
      </tr>
      <tr>
        <td>
          <abcDatepicker
            #validFromInput
            id="DateStart"
            [style]="4"
            [placeholder]="'Valid from'"
            [width]="'95%'"
            [height]="'40px'"
          ></abcDatepicker>
        </td>
        <td>
          <abcDatepicker
            #validUntilInput
            id="DateEnd"
            [style]="4"
            [placeholder]="'Valid until'"
            [width]="'95%'"
            [height]="'40px'"
          ></abcDatepicker>
        </td>
      </tr>
    </table>

    <table class="textAreaComment">
      <tr>
        <abcTextArea #Comment [id]="'Comment'" [width]="'100%'" [height]="'111px'" [placeholder]="'Comment'">
        </abcTextArea>
      </tr>
    </table>

    <table style="width: 100%; height: 25px; border-spacing: 10px">
      <tr>
        <td style="width: 50%">
          <label>inserted On: </label>
          <span>{{ document?.InsertDate }}</span>
        </td>
        <td style="width: 50%">
          <label>last Update On: </label>
          <span>{{ document?.UpdateDate }}</span>
        </td>
      </tr>
    </table>
  </div>
  <abcButton
    style="margin-left: 10px"
    #openButton
    id="button-Open"
    [width]="'20%'"
    [height]="'40px'"
    [value]="'Open'"
  ></abcButton>
  <div class="buttonsEvents" fxLayout="row" fxLayoutGap="5px">
    <abcButton #resetButton id="button-Reset" [width]="'35%'" [height]="'40px'" [value]="'Reset'"> </abcButton>
    <abcButton #okButton id="button-Ok" [width]="'35%'" [height]="'40px'" [value]="'Ok'"></abcButton>
    <abcButton #cancelButton id="button-Cancel" [width]="'70px'" [height]="'40px'" [value]="'Cancel'"> </abcButton>
  </div>
</div>
